<header
  class="header-container"
  [class.header-container--scrolled]="isScrolled">
  <div class="header-row">
    <a
      class="header-logo"
      routerLink="/"
      [attr.aria-label]="'LcHeaderComponent.GoToHomepage' | translate">
      <img
        class="logo-full"
        ngSrc="/assets/images/svg/lawyerty.svg"
        height="170"
        width="949"
        priority
        [attr.alt]="'LcHeaderComponent.LawyertyLogo' | translate" />
    </a>

    <div class="header-center">
      <ng-content select="[slot=center]" />
    </div>

    <div class="header-right">
      <div class="header-right-content">
        <lc-header-icons
          [isUserLoggedIn]="isUserLoggedIn"
          [newMessages]="newMessages"
          [hasNotifications]="hasNotifications"
          [notifications]="notifications"
          (markNotificationAsReadEvent)="markNotificationAsRead($event)" />
        @if (isUserLoggedIn) {
          <div class="profile-panel-container">
            <profile-user-button
              [firstName]="userName"
              [lastName]="userSurname" />
          </div>
        }
      </div>
    </div>
  </div>
</header>
